type SpriteProps = { content: string };

export const Sprite = ({ content }: SpriteProps) => (
    <div
        style={{ display: 'none' }}
        id="svg-critical-sprite"
        dangerouslySetInnerHTML={{
            __html: content
        }}
    />
);
